import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterSelect, FilterSelectAsync, FilterTimePicker } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import { purchaseParticipantStatus } from '../../enums/purchaseParticipantStatus';
import { purchaseParticipantType } from '../../enums/purchaseParticipantType';
import {
  DisplayGuid,
  DisplayDate,
  DisplayType,
  DisplayStatus,
  DisplayPercentage
} from '../items';
import AddEntityButton from '../misc/AddEntityButton';

const resultsCount = 15;

class ParticipantsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  componentDidMount() {
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { participants: { searchParticipant } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchParticipant({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;
    const { history, api } = this.props;
    const {
      providers: {
        lookupByNameOrId: lookupProvider
      },
      facilities: {
        lookupByNameOrId: lookupFacility
      },
      users: {
        lookupByEmailOrId: lookupUser
      }
    } = api;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Participants page'
              documentDescription='Participants page'
            />

            <h2 className='main-page-header'>
              Participants
              <AddEntityButton to='/participant' />
            </h2>

            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                participantId,
                purchaseId,
                purchaseProductId,
                name,
                type,
                providerId,
                userId,
                facilityId,
                afterAt,
                beforeAt,
                billingAfterAt,
                billingBeforeAt,
                occursAfterAt,
                occursBeforeAt,
                status
              }, updatedKey) => {
                if (updatedKey !== 'participantId') {
                  return {
                    name,
                    type,
                    status,
                    purchaseId,
                    providerId,
                    userId,
                    facilityId,
                    afterAt,
                    beforeAt,
                    billingAfterAt,
                    billingBeforeAt,
                    occursAfterAt,
                    occursBeforeAt,
                    purchaseProductId
                  };
                }
                return { participantId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='participantId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='participantId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='purchaseId'>
                      Purchase Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='purchaseId'
                      placeholder='Find by purchase id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='purchaseProductId'>
                      Purchase Pr. Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='purchaseProductId'
                      placeholder='Find by purchase product id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='type'>
                      Type
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='type'
                      options={purchaseParticipantType}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='type'>
                      Status
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='status'
                      options={purchaseParticipantStatus}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='providerId'>
                      Provider
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      debounce
                      update={update}
                      name='providerId'
                      loadOptions={async inputValue => lookupProvider(inputValue)}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='userId'>
                      User
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='userId'
                      loadOptions={async inputValue => lookupUser(inputValue)}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='facilityId'>
                      Facility
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      debounce
                      update={update}
                      name='facilityId'
                      loadOptions={async inputValue => lookupFacility(inputValue)}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='afterAt'>
                      From
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='afterAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='beforeAt'>
                      To
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='beforeAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='billingAfterAt'>
                      Billing From
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='billingAfterAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='billingBeforeAt'>
                      Billing To
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='billingBeforeAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='occursAfterAt'>
                      Occurs From
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='occursAfterAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='occursBeforeAt'>
                      Occurs To
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='occursBeforeAt'
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'participants',
                rowClasses: 'hover-listview',
                rowClick: ({ Id }) => {
                  history.push(`/participant/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  },
                  {
                    property: 'Status',
                    label: 'Status',
                    type: 'string',
                    render: ({ Status }) => <DisplayStatus mapping={purchaseParticipantStatus}>{Status}</DisplayStatus>
                  }, {
                    property: 'InviteeName',
                    label: 'Name',
                    type: 'string'
                  },
                  {
                    property: 'Type',
                    label: 'Type',
                    type: 'string',
                    render: ({ Type }) => <DisplayType mapping={purchaseParticipantType}>{Type}</DisplayType>
                  },
                  {
                    property: 'MembershipSlots',
                    label: 'Slots',
                    type: 'string'
                  },
                  {
                    property: 'Index',
                    label: 'Index',
                    type: 'string',
                    render: ({ ParticipantsIndex: Index }) => <DisplayPercentage>{Index}</DisplayPercentage>
                  },
                  {
                    property: 'CreatedAtCet',
                    label: 'Created At (CET)',
                    render: ({ CreatedAtCet }) => <DisplayDate>{CreatedAtCet}</DisplayDate>
                  },
                  {
                    property: 'OccursAtCet',
                    label: 'Occurs At (CET)',
                    render: ({ OccursAtCet }) => <DisplayDate>{OccursAtCet}</DisplayDate>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);

                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Participants = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(ParticipantsInternal)
));

Participants.requiresLogin = true;
Participants.propTypes = { isLoggedIn: PropTypes.bool };

export default Participants;
